import React from 'react';
import { AlertCircle, MessageSquare, Target, TrendingDown, Users, Shield, FileText, HelpCircle } from 'lucide-react';

export const ProblemSection = () => {
  const situations = [
    {
      icon: HelpCircle,
      text: "Vos prospects posent toujours les mêmes questions avant de vous faire confiance."
    },
    {
      icon: FileText,
      text: "Votre communication présente beaucoup de services, mais aucune priorité claire."
    },
    {
      icon: TrendingDown,
      text: "Vos meilleurs arguments apparaissent trop tard dans le parcours."
    },
    {
      icon: Target,
      text: "Votre discours ne reflète plus l'évolution réelle de l'entreprise."
    },
    {
      icon: Users,
      text: "Vous attirez des demandes qui correspondent mal aux clients recherchés."
    },
    {
      icon: Shield,
      text: "Vos concurrents semblent plus rassurants alors que leur offre n'est pas meilleure."
    },
    {
      icon: MessageSquare,
      text: "Votre site explique votre activité sans véritablement montrer pourquoi vous choisir."
    },
    {
      icon: AlertCircle,
      text: "Plusieurs interlocuteurs présentent votre entreprise de manière différente."
    }
  ];

  return (
    <section id="probleme" className="py-32 bg-gray-50 relative overflow-hidden">
      <div className="container-custom relative z-10">
        <div className="max-w-5xl mx-auto fade-in-section">
          <h2 className="section-title mb-6 text-center">
            Le problème ne vient pas toujours<br />
            de la qualité de votre offre.
          </h2>
          
          <p className="section-intro text-center mb-16 max-w-3xl mx-auto">
            Il arrive qu'une entreprise possède une véritable valeur, mais qu'elle ne soit pas perçue, ni par les bonnes personnes, ni pour les bonnes raisons.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-16">
            {situations.map((situation, index) => (
              <div 
                key={index} 
                className="flex items-start gap-4 p-6 bg-white rounded-lg border border-gray-200 hover:border-accent hover:shadow-md transition-all"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg">
                  <situation.icon className="h-5 w-5 text-accent" />
                </div>
                <p className="text-gray-700 leading-relaxed">{situation.text}</p>
              </div>
            ))}
          </div>

          <div className="text-center p-8 bg-white border-l-4 border-accent rounded-lg">
            <p className="text-xl text-gray-900 font-medium">
              Ces problèmes ne réclament pas forcément davantage de communication.<br />
              Ils réclament d'abord un <span className="text-accent font-semibold">diagnostic juste</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
